export const EXPAND_COLUMN = {} as const;
